export abstract class _Tag {
  id: any;
  name: any;
  description:string;
}